import { Link } from "react-router-dom";
import { FiBriefcase, FiArrowRight } from "react-icons/fi";

/**
 * Aviso para o anunciante que já está anunciando com o cadastro incompleto.
 *
 * Não bloqueia nada — só lembra que o CNPJ é o que libera o selo de fornecedor
 * verificado e preenche o nome da empresa na vitrine.
 */
const CompanyDraftNotice = ({ company }) => {
  if (!company?.isDraft) return null;

  return (
    <div className="company-draft">
      <span className="company-draft__icon">
        <FiBriefcase size={18} />
      </span>
      <div className="company-draft__text">
        <strong>Complete o cadastro da sua empresa</strong>
        <span>
          Você já pode cadastrar produtos e anunciar. Preencher o CNPJ libera o selo
          de <strong>fornecedor verificado</strong> e faz seu nome aparecer nos
          anúncios da vitrine.
        </span>
      </div>
      <Link className="company-draft__action" to="/empresa">
        Completar agora
        <FiArrowRight size={14} />
      </Link>
    </div>
  );
};

export default CompanyDraftNotice;
